import { axiosInstance } from '@/services/http';
import { CRMS_ENDPOINT } from '@/utilities/constants/api';

export const CRM_FORM = {
  getSession: async () => {
    return await axiosInstance.get(`${CRMS_ENDPOINT.getToken}`);
  },
  getClarification: async (encryptedFormParam: string) => {
    return await axiosInstance.get(`${CRMS_ENDPOINT.clarification}`, {
      params: { encryptedFormParam },
      headers: {
        'transaction-id': window.sessionStorage.getItem('transactionId') || '',
      },
    });
  },
  submitClarification: async (data: unknown, captchaToken: string) => {
    return await axiosInstance.post(`${CRMS_ENDPOINT.clarification}`, data, {
      headers: {
        'g-recaptcha-response': captchaToken,
      },
    });
  },
  getInputForm: async (encryptedFormParam: string) => {
    return await axiosInstance.get(`${CRMS_ENDPOINT.input}`, {
      params: { encryptedFormParam },
      headers: {
        'transaction-id': window.sessionStorage.getItem('transactionId') || '',
      },
    });
  },
  submitInput: async (data: unknown, captchaToken: string) => {
    return await axiosInstance.post(`${CRMS_ENDPOINT.input}`, data, {
      headers: {
        'g-recaptcha-response': captchaToken,
      },
    });
  },
  getSurveyForm: async (encryptedFormParam: string) => {
    return await axiosInstance.get(`${CRMS_ENDPOINT.survey}`, {
      params: { encryptedFormParam },
      headers: {
        'transaction-id': window.sessionStorage.getItem('transactionId') || '',
      },
    });
  },
  submitSurveyForm: async (data: unknown, captchaToken: string) => {
    return await axiosInstance.post(`${CRMS_ENDPOINT.survey}`, data, {
      headers: {
        'g-recaptcha-response': captchaToken,
      },
    });
  },
  getSurveyUnsubscribe: async (encryptedFormParam: string) => {
    return await axiosInstance.get(`${CRMS_ENDPOINT.surveyUnsubscribe}`, {
      params: { encryptedFormParam },
      headers: {
        'transaction-id': window.sessionStorage.getItem('transactionId') || '',
      },
    });
  },
  submitSurveyUnsubscription: async (data: unknown, captchaToken: string) => {
    return await axiosInstance.post(
      `${CRMS_ENDPOINT.surveyUnsubscribe}`,
      data,
      {
        headers: {
          'g-recaptcha-response': captchaToken,
        },
      }
    );
  },
  submitFeedback: async (data: unknown, captchaToken: string) => {
    return await axiosInstance.post(`${CRMS_ENDPOINT.submitFeedback}`, data, {
      headers: {
        'g-recaptcha-response': captchaToken,
      },
    });
  },
};
